export const KNOWLEDGE_EXPERT_AGENT_ID = "97e82c3a-b856-4fec-a47f-74d12b0ca9c0" as const;
export const KNOWLEDGE_EXPERT_AGENT_KEY = "knowledge-expert" as const;
export const KNOWLEDGE_EXPERT_DISPLAY_NAME = "知识库专家" as const;
export const KNOWLEDGE_EXPERT_DESCRIPTION =
  "帮你查找知识库资料、解答问题，并附上参考来源。" as const;
export const KNOWLEDGE_EXPERT_MATRIX_LOCALPART = "knowledge-expert" as const;
